import { lazyWithRetry } from "utils";

export const UserManagement = lazyWithRetry(() => import("./containers/index"));
export const UserDetails = lazyWithRetry(() => import("./containers/UserDetails"));